module.exports = __webpack_public_path__ + "static/media/addPoint.7edcaa3b.svg";